import {
  Directive,
  ElementRef,
  Input,
  HostListener,
  Injectable,
  Output,
  EventEmitter,
} from "@angular/core";

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable()
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}

@Directive({
  selector: "[stick]",
  providers: [WindowRef],
})
export class StickDirective {
  _className: string = "stick";
  _cHead;
  _cTableBody;
  heightTrigger;

  @Input("stickClass") set stickClass(className: string) {
    this._className = className || this._className;
  }

  @Input("cHead") set cHead(cHeadElement: any) {
    this._cHead = cHeadElement;
  }

  @Input("cTableBody") set cTableBody(cTableBodyElement: any) {
    this._cTableBody = cTableBodyElement;
  }

  @Output() headerIsStuck = new EventEmitter();

  constructor(private _element: ElementRef, private _window: WindowRef) {}

  @HostListener("window:scroll", ["$event"])
  handleScrollEvent(e) {
    if (this._cHead) {
      let box = this._cHead.nativeElement.getBoundingClientRect();
      let height = box.height;
      if (box.top != 0) {
        // as long as the header is not stuck to the top of the page (at top: 0), reset the height trigger
        // so that it will pick up any changes to header height on the page (like if the user selects a dropdown on mobile)
        this.heightTrigger = this._window.nativeWindow.pageYOffset + box.top;
      }
      if (this._window.nativeWindow.pageYOffset >= this.heightTrigger) {
        this._element.nativeElement.classList.add(this._className);
        this._cTableBody.nativeElement.style.paddingTop = height + "px";
        this.headerIsStuck.emit(true);
      } else {
        this._element.nativeElement.classList.remove(this._className);
        this._cTableBody.nativeElement.style.paddingTop = 0;
        this.headerIsStuck.emit(false);
      }
    }
  }
}
